__turbopack_context__.v({
  "button": "amount-quick-select-module-scss-module__ko7G-a__button",
  "button-column": "amount-quick-select-module-scss-module__ko7G-a__button-column",
  "button-row": "amount-quick-select-module-scss-module__ko7G-a__button-row",
  "recommended-amount": "amount-quick-select-module-scss-module__ko7G-a__recommended-amount",
  "wrapper": "amount-quick-select-module-scss-module__ko7G-a__wrapper",
});
